export class ListSaasEntitySnapshotsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "SaasEntityType",
            "format": ""
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitySnapshotsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
